import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { useDrawer } from '../../hooks/use-drawer';
import { InstantCheckoutDrawer } from '../../instant-checkout-myaccount-preferences';
import {
  SETUP_HOW_YOU_PAY,
  ADD_PAYMENT,
  SELECT_PAYMENT,
} from '../../models/views';
import { usePayments } from '../../hooks/use-payments';

export const SetupButton = () => {
  const { openDrawer, hideDrawer } = useDrawer();
  const onSetup = (initialView: string) => () => {
    openDrawer(InstantCheckoutDrawer, {
      hideDrawer,
      initialView,
      flowName: SETUP_HOW_YOU_PAY,
    });
  };
  const { hasPayments } = usePayments();
  const VIEW = hasPayments() ? SELECT_PAYMENT : ADD_PAYMENT;
  return (
    <Button
      data-testid="checkout-btn-setup-nested"
      fullWidth
      // customer has NO payments saved to their account INITIAL_ENROLLMENT
      // customer has payments saved to their account ADD_PAYMENT
      onClick={onSetup(VIEW)}
    >
      Set Up How You Pay
    </Button>
  );
};
